import "../assets/About.css";

export default function About() {
  return (
    <div>
      <div className="about-container">
        <div className="left">
          <h1>Overview</h1>
          <h2>
            B[U]ILT Air Canvas is an interactive Engineering Open House exhibit
            that lets visitors “draw in the air” using Disney-style ESP32 wands
            or hand gestures tracked by a webcam, turning motion into real-time
            visualizations on a screen
          </h2>
        </div>

        <div className="right">

        </div>
      </div>
    </div>
  );
}
